import { Component, Inject, OnInit } from '@angular/core';
import { _, moment, mySynchModules } from '../../../js/globals';
import { MySynchDataStore } from '../../data-stores/mysynch.datastore';
import { ClientLoggerService } from '../../services/client-logger.service';
import { MySynchConstantService } from '../../services/mysynch.constant.service';
import { MySynchEnumerationService } from '../../services/mysynch.enumeration.service';
import { PerformanceContextService } from '../../services/performance-context.service';
import { PerformanceMetricsService } from '../../services/performance-metrics.service';
import { PerformanceContext } from '../../interfaces/mysynch.interfaces';
import { LoginData, LoginInputs } from './login.interfaces';

const config = mySynchModules.config;

@Component({
    standalone: false,
    selector: 'login',
    templateUrl: '../app/pages/login/login.view.html',
    styleUrls: ['../app/pages/login/login.style.css']
    })
export class Login implements OnInit {

    private performanceContext: PerformanceContext | null = null;
    private finalizeLoginData: LoginData = {
        loginId: '',
        password: '',
        expires: ''
    };

    loading: boolean = false;
    hasSubmittedLogin: boolean = false;
    inputs: LoginInputs = {
        loginId: '',
        password: ''
    };

    constructor(@Inject('MySynchFactory') private MSF:any,
                @Inject('ApiFactory') private api:any,
                @Inject('ViewAuthorizationFactory') private viewAuth:any,
                @Inject('CookieFactory') private cookies:any,
                @Inject(MySynchDataStore) private mySynchDataStore:MySynchDataStore,
                @Inject(MySynchEnumerationService) private mySynchEnumSvc:MySynchEnumerationService,
                @Inject(MySynchConstantService) private mysynchConstSvc:MySynchConstantService,
                @Inject(PerformanceMetricsService) private perfMetricSvc:PerformanceMetricsService,
                @Inject(PerformanceContextService) private perfContextSvc:PerformanceContextService,
                @Inject(ClientLoggerService) private log:ClientLoggerService){ }

    ngOnInit(): void {
        this.redirectActiveUsers();
    }

    private resetDefaults(): void {
        this.loading = false;
        this.inputs = {
            loginId: '',
            password: ''
        };
    }

    redirectActiveUsers(): void {
        this.performanceContext = this.perfContextSvc.createPerformanceContext();
        this.perfMetricSvc.startTiming('Page:Login:Render');
        this.perfMetricSvc.startTiming('Page:Login:Build');
        // redirect active users to home
        if (this.viewAuth.checkUser()) {

            var optionalParams = {};
            var rolesByFarm = _.get(this.MSF.cookies.user,'rolesByFarm',[]);
            var isTM = _.some(rolesByFarm,(role:any)=>{
                return _.includes(_.keys(role),this.mySynchEnumSvc.getMySynchEnumerationName("Role","TERRITORY_MANAGER"));
            });
            // if the user is a territory manager, we need to supply the default tab name of the territory dashboard
            if (isTM) {
                _.set(optionalParams,'selectedTabName',this.mysynchConstSvc.defaultTerritoryManagerDashboardTab);
            }
            this.perfMetricSvc.endTiming("page",'Page:Login:Build', this.performanceContext);
            this.perfMetricSvc.markPageReady('Page:Login:Render', this.performanceContext);
            var homePageStateName = this.MSF.getUserHomepageStateName();
            this.MSF.loadPage(homePageStateName,optionalParams);
        } else {
            this.resetDefaults();
            this.perfMetricSvc.endTiming("page",'Page:Login:Build', this.performanceContext);
            this.perfMetricSvc.markPageReady('Page:Login:Render', this.performanceContext);
        }
    }

    forgotPasswordClicked(): void {
        this.MSF.loadPage('ForgotPassword');
    }

    submitLogin(): void {
        const isEmptyOrNull = (str:any) => {
            return _.isEmpty(str) || _.isNull(str);
        };

        var loginData: LoginData = {
            loginId: this.inputs.loginId,
            password: this.inputs.password,
            expires: +moment(_.get(_.find(config.cookies,{key: 'user'}),'options.expires'))
        };
        this.finalizeLoginData = _.cloneDeep(loginData);
        var msg:string[] = [];

        if (isEmptyOrNull(loginData.loginId)) {
            msg.push('Email');
        }

        if (isEmptyOrNull(loginData.password)) {
            msg.push('Password');
        }

        if (!_.isEmpty(msg)) {
            var msgString = msg.join(' and ') + (msg.length > 1 ? ' are required fields' : ' is a required field');

            this.MSF.notify.danger(msgString);

            return this.log.warn(msgString);
        }

        this.log.debug('submitting login');

        this.loading = true;

        this.api.login(loginData, (err:any, data:any) => {
            if (err) {
                this.log.error({err: err} as any);
                this.MSF.notify.danger(err);
                this.loading = false;

                this.cookies.user = {};
                this.cookies.save();

                return this.log.error(err);
            }

            this.log.info('logged in OK', data);
            var rolesByFarm = _.get(data,'rolesByFarm',[]);
            var isA_SA_PV_TM = _.some(rolesByFarm,(role:any)=>{
                return _.includes(
                            _.keys(role),
                            this.mySynchEnumSvc.getMySynchEnumerationName("Role","SUPER_ADMIN")
                       ) ||   _.includes(_.keys(role),this.mySynchEnumSvc.getMySynchEnumerationName("Role","PARNELL_VIEWER"))
                         ||   _.includes(_.keys(role),this.mySynchEnumSvc.getMySynchEnumerationName("Role","TERRITORY_MANAGER"));
            });
            this.cookies.user = _.extend(data, {token: this.cookies.user.token});
            if(!isA_SA_PV_TM){
                this.MSF.loadFarmsAfterLogin((err:any, data:any) => {
                    this.loading = false;

                    if (err) {
                        this.log.error('failed to load farms after login: ' + err);
                    }
                    var homePageStateName = this.MSF.getUserHomepageStateName(true);
                    this.mySynchDataStore.onUserChanged(this.MSF.cookies.user);

                    this.MSF.loadPage(homePageStateName);

                });
            }else{
                this.cookies.save();
                this.hasSubmittedLogin = true;
            }
        });
    }

    finalizeLogin(deviceOwner:string): void {

        var optionalParams = {};
        var rolesByFarm = _.get(this.MSF.cookies.user,'rolesByFarm',[]);
        var isTM = _.some(rolesByFarm,(role:any)=>{
            return _.includes(_.keys(role),this.mySynchEnumSvc.getMySynchEnumerationName("Role","TERRITORY_MANAGER"));
        });
        // if the user is a territory manager, we need to supply the default tab name of the territory dashboard
        if (isTM) {
            _.set(optionalParams,'selectedTabName',this.mysynchConstSvc.defaultTerritoryManagerDashboardTab);
        }

        switch(deviceOwner){
            case "mine":
                console.log("this device is mine");
                this.MSF.loadFarmsAfterLogin((err:any, data:any) => {
                    this.loading = false;

                    if (err) {
                        this.log.error('failed to load farms after login: ' + err);
                    }

                    var homePageStateName = this.MSF.getUserHomepageStateName(true);

                    this.mySynchDataStore.onUserChanged(this.MSF.cookies.user);

                    this.MSF.loadPage(homePageStateName,optionalParams);

                });
            break;
            case "someone_else":
                console.log("this device is someone else's");
                _.set(this.finalizeLoginData,'expires',+moment().add(30,'minutes'));
                this.api.login(this.finalizeLoginData, (err:any, data:any) => {
                    if (err) {
                        this.log.error({err: err} as any);
                        this.MSF.notify.danger(err);
                        this.loading = false;

                        this.cookies.user = {};
                        this.cookies.save();

                        return this.log.error(err);
                    }

                    this.cookies.user = _.extend(data, {token: this.cookies.user.token});

                    this.MSF.loadFarmsAfterLogin((err:any, data:any) => {
                        this.loading = false;

                        if (err) {
                            this.log.error('failed to load farms after login: ' + err);
                        }
                        var homePageStateName = this.MSF.getUserHomepageStateName(true);

                        this.mySynchDataStore.onUserChanged(this.MSF.cookies.user);

                        this.MSF.loadPage(homePageStateName,optionalParams);

                    });
                });
            break;
        }

    }
}
